import { useCallback, useState } from 'react';
import { ConditionsView, setUserProperties, trackEvent } from '@shared/utils';

export const calculusCombinedViewItem = 'calculusCombinedView';

export const getStoredCalculusView = (): ConditionsView => {
  const stored = localStorage.getItem(calculusCombinedViewItem);
  if (stored === null) return 'not_set';
  return stored === 'true' ? 'combined' : 'separate';
};

export const useCalculusCombinedView = () => {
  const [hasStoredPreference, setHasStoredPreference] = useState(
    () => localStorage.getItem(calculusCombinedViewItem) !== null
  );

  const [combinedView, setCombinedViewState] = useState(
    () => localStorage.getItem(calculusCombinedViewItem) === 'true'
  );

  const setCombinedView = useCallback((value: boolean) => {
    const from = getStoredCalculusView();
    const to: ConditionsView = value ? 'combined' : 'separate';
    localStorage.setItem(calculusCombinedViewItem, String(value));
    setCombinedViewState(value);
    setHasStoredPreference(true);
    setUserProperties({ conditions_view: to });
    trackEvent('conditions_view_changed', { from, to });
  }, []);

  return { combinedView, setCombinedView, hasStoredPreference };
};
